import { useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { parse } from "shared/helpers/serialization";
import { validateDiagnosePurchase } from "shared/service/StrmService";

const CheckoutDiagnostico: React.FC<RouteComponentProps> = (props) => {
  const { location, history } = props;

  useEffect(() => {
    async function validatePurchase() {
      const returnState = parse(location.search.replace("?", ""));
      if (
        returnState.status === "approved" ||
        returnState.status === "in_process"
      ) {
        await validateDiagnosePurchase(returnState.payment_id as any);

        history.push("/confirmacao", { success: true });
      } else {
        history.push("/diagnostic", { error: true });
      }
    }

    if (location.search) {
      validatePurchase();
    }
  }, [location, history]);

  return null;
};

export default CheckoutDiagnostico;
